// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FormContainer_forceLtr__ecLVh {
  direction: ltr !important;
  font-family: Inter !important;
  /* font-family: Estedad !important; */
}
`, "",{"version":3,"sources":["webpack://./src/Components/UI/FormContainer/FormContainer.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,qCAAqC;AACvC","sourcesContent":[".forceLtr {\r\n  direction: ltr !important;\r\n  font-family: Inter !important;\r\n  /* font-family: Estedad !important; */\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"forceLtr": `FormContainer_forceLtr__ecLVh`
};
export default ___CSS_LOADER_EXPORT___;
